import { CONTENT_API_BASE_URL } from '../../utils/constants';
import { SemboMarket } from '../../utils/markets';
import {
  DestinationAutoCompleteSuggestion,
  GetFerryRouteResult,
  GetSuggestedAirportBySearchTextResult,
  GetVehicleTypeResult,
} from './ContentService.types';

export const ContentService = {
  getCategorizedAutocompleteSuggestions: async (
    input: string,
    marketHost: string
  ): Promise<DestinationAutoCompleteSuggestion[]> => {
    const url = `${CONTENT_API_BASE_URL}/CategorizedAutosuggestion?term=${encodeURIComponent(input)}`;
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'X-Sembo-Host': marketHost,
      },
    });

    return response.json();
  },

  getSuggestedAirportBySearchText: async (
    searchText: string,
    options: {
      size: number;
    },
    market: SemboMarket
  ): Promise<GetSuggestedAirportBySearchTextResult> => {
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Sembo-Host': market.host,
        'X-Sembo-App': 'Inspire',
      },
    };
    const response = await fetch(
      `${CONTENT_API_BASE_URL}/Autosuggestion?&Types=Airport&Page=0&Size=${options.size}&Term=${searchText}`,
      requestOptions
    );

    const data = await response.json();

    return data
      ?.filter((item: any) => item.type === 'airport')
      .map((item: any) => ({
        ...item.airport,
        airportConnection: item.airportConnection,
      })) as GetSuggestedAirportBySearchTextResult;
  },

  getFerryRoutes: async (
    searchText: string,
    market: SemboMarket,
    options?: Record<string, string>
  ): Promise<GetFerryRouteResult> => {
    const url = new URL(`${CONTENT_API_BASE_URL}/Autosuggestion`);
    url.searchParams.append('Types', 'FerryRoute');
    url.searchParams.append('Term', searchText);

    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        url.searchParams.append(key, value);
      });
    }

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Sembo-Host': market.host,
        'X-Sembo-App': 'Inspire',
      },
    });

    return response.json();
  },

  getVehicleTypes: async (
    market: SemboMarket
  ): Promise<GetVehicleTypeResult> => {
    const response = await fetch(`${CONTENT_API_BASE_URL}/VehicleTypes`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Sembo-Host': market.host,
        'X-Sembo-App': 'Inspire',
      },
    });

    return response.json();
  },
};
